<template>
    <div class="hello-ezuikit-js">
        <div id="video-container" style="width:375px;height:200px"></div>
    </div>
</template>

<script>
import EZUIKit from "ezuikit-js";

var player = null;

export default {
    name: "HelloWorld",
    props: {
        msg: String
    },
    mounted () {
        let url = this.GetQueryString('urlVideo')
        let token = this.GetQueryString('token')
        player = new EZUIKit.EZUIKitPlayer({
            id: 'video-container', // 视频容器ID
            accessToken: token,
            url ,
            // simple - 极简版; pcLive-pc直播；pcRec-pc回放；mobileLive-移动端直播；mobileRec-移动端回放;security - 安防版;voice-语音版;
            template: 'mobileLive',
            plugin: ['talk'], // 加载插件，talk-对讲
            width: 375,
            height: 211,
        });
        window.player = player;
    },
    methods: {
        GetQueryString(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return unescape(r[2]);
            return null;
        }
    }
};
</script>
<style>
.hello-ezuikit-js{
    width: 375px;
}
</style>
